import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Layout from "../layout/Layout";

const LandingPage = lazy(() => import("../pages/LandingPage"));
const Portfolio = lazy(() => import("../pages/Portfolio"));
const Page404 = lazy(() => import("../components/Page404"));

export default function AppRoutes() {
	return (
		<BrowserRouter>
			<Suspense
				fallback={
					<div className="d-flex justify-content-center align-items-center vh-100">
						<div className="spinner-border text-primary" role="status">
							<span className="visually-hidden">Loading...</span>
						</div>
					</div>
				}
			>
				<Routes>

					<Route path="/" element={<Layout />}>

						<Route index element={<LandingPage />} />

						<Route path="portfolio" element={<Portfolio />} />

						{/* Future Pages */}
						{/* <Route path="about" element={<About />} /> */}
						{/* <Route path="products" element={<Products />} /> */}
						{/* <Route path="contact" element={<Contact />} /> */}

						<Route path="*" element={<Page404 />} />

					</Route>

				</Routes>
			</Suspense>
		</BrowserRouter>
	);
}